<template>
  <div class="rechargeBox">
    <div class="jiangli_top">
      <img @click="fanhui()" src="../../assets/images/licai/fanhui.png" />
      <p class="">充值</p>
    </div>
    <div class="pay">
      <div class="pay_int">
        <p class="pay_int_tit">提现金额</p>
        <div class="pay_int_shuru">
          <p class="">￥</p>
          <input placeholder="" />
        </div>
      </div>
      <button class="pay_but" @click="jinxing()">下一步</button>
    </div>
    <div class="pay_popup" v-if="zhanshi == 0"></div>
    <div class="pay_popups" v-if="zhanshi == 0">
      <img @click="close()" src="../../assets/images/close.png" />
      <div class="pay_popups_price">
        <p class="">充值</p>
        <div style="display: flex;align-items: center;justify-content: center;">
          <p>￥</p>
          5.00
        </div>
      </div>
      <div class="pay_popups_card">
        <p class="">付款方式</p>
        <p class="" style="margin-left: 35px;">招商银行储蓄卡 （9125）</p>
        <img
          style="width: 20px;height: 23px;"
          src="../../assets/images/licai/right.png"
        />
      </div>
      <button class="liji">立即付款</button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { pay } from "@libs/wechat";
import { VUE_APP_API_URL, isWeixin } from "@utils";
// import { isWeixin,VUE_APP_API_URL } from "@utils";
import {
  rechargeWechat,
  getRechargeApi,
  getPayApi,
  getUserInfo
} from "@api/user";
import { add, sub } from "@utils/bc";
import VueCoreImageUpload from "vue-core-image-upload";
export default {
  name: "Recharge",
  props: {},
  components: {
    VueCoreImageUpload
  },
  data: function() {
    return {
      url: `${VUE_APP_API_URL}/upload/image`,
      headers: {
        "Authori-zation": "Bearer " + this.$store.state.app.token
      },
      avatar: "",
      navRecharge: ["账户充值"],
      active: 0,
      payType: ["weixin"],
      from: isWeixin() ? "weixin" : "weixinh5",
      money: "",
      now_money: "",
      picList: [],
      shows: 1,
      picItem: [],
      activePic: 0,
      numberPic: "",
      rechar_id: 0,
      rechargeAttention: [],
      zhanshi: 1,
      selects: [
        // {key: 1, value: "支付宝"},
        {
          key: 1,
          value: "数字人民币"
        }
      ],
      couponSelected: ""
    };
  },
  computed: mapGetters(["userInfo"]),
  mounted: function() {},
  created() {
    //如果没有这句代码，select中初始化会是空白的，默认选中就无法实现
    this.couponSelected = this.selects[0].key;
  },
  methods: {
    close: function() {
      if (this.zhanshi == 0) {
        this.zhanshi = 1;
      } else {
        this.zhanshi = 0;
      }
    },
    jinxing: function() {
      if (this.zhanshi == 0) {
        this.zhanshi = 1;
      } else {
        this.zhanshi = 0;
      }
    },
    fanhui: function() {
      this.$router.push({
        path: "/"
      });
    }
  }
};
</script>
<style scoped>
.liji {
  width: 100%;
  background-color: #ff1900;
  color: #ffffff;
  text-align: center;
  margin-top: 20px;
  height: 50px;
  font-size: 18px;
  margin-top: 15%;
}
/* 充值框 */
.pay_popups_card {
  display: flex;
  align-items: center;
}
.pay_popups_card img {
  margin-left: auto;
  width: 20px;
}
.pay_popups_card p {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000;
  line-height: 53px;
}
.pay_popups_price {
  width: 100%;
  border-bottom: 1px solid #999999;
}
.pay_popups img {
  width: 35px;
  height: 35px;
}
.pay_popups_price p {
  text-align: center;
  font-size: 18px;
  color: #000000;
  line-height: 30px;
}
.pay_popups_price div {
  font-size: 30px;
  color: #000;
  text-align: center;
  line-height: 68px;
}
.pay_popups_price div p {
  font-size: 18px;
  color: #000000;
}
.pay_popup {
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  left: 0px;
  bottom: 0px;
}
.pay_popups {
  width: 100%;
  height: 378px;
  background-color: #ffffff;
  border-radius: 5px;
  z-index: 99;
  position: absolute;
  left: 0px;
  bottom: 0px;
  padding: 15px;
}

.pay_int {
  width: 100%;
  padding: 15px;
  background-color: #ffffff;
}

.pay_int_tit {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}

.pay_int_shuru {
  display: flex;
  align-items: center;
}

.pay {
  padding: 15px;
}

.pay_but {
  width: 100%;
  background-color: #ff1900;
  color: #ffffff;
  text-align: center;
  margin-top: 20px;
  height: 50px;
  font-size: 18px;
}

.pay_int_shuru p {
  font-size: 35px;
  color: #000000;
}

.pay_int_shuru input {
  margin-left: 10px;
  font-size: 24px;
}

.rechargeBox {
  height: 100%;
  background: #eceeed;
}

#iframe {
  display: none;
}

.yinhangka {
  width: 100%;
}

.erweima img {
  width: 100px !important;
  height: auto !important;
}

/* .pic-box-color-active {
		background-color: #ec3323 !important;
		color: #fff !important;
	} */
.jiangli_top {
  width: 100%;
  height: 45px;
  line-height: 45px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
}

.jiangli_top img {
  height: 30px;
  width: 30px;
  position: absolute;
  left: 0px;
}

.jiangli_top p {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  text-align: center;
}

.selects_d {
  width: 100%;
  background-color: #ec3323;
  color: #fff;
  border-radius: 0.1rem;
  margin-top: 0.21rem;
  padding: 0.3rem 0.2rem;
  display: flex;
}

.selects_d select {
  color: #999;
}

.selects_d img {
  width: 60px;
  height: 60px;
}

.pic-box-active {
  width: 2.16rem;
  height: 1.2rem;
  background-color: #ec3323;
  border-radius: 0.2rem;
}

.picList {
  margin-bottom: 0.3rem;
  margin-top: 0.3rem;
}

.font-color {
  color: #e83323;
}

.recharge {
  border-radius: 0.1rem;
  width: 100%;
  background-color: #fff;
  margin: 0.2rem auto 0 auto;
  padding: 0.3rem;
  border-top-right-radius: 0.39rem;
  border-top-left-radius: 0.39rem;
  margin-top: -0.45rem;
  box-sizing: border-box;
}

.recharge .nav {
  height: 0.75rem;
  line-height: 0.75rem;
  padding: 0 1rem;
}

.recharge .nav .item {
  font-size: 0.3rem;
  color: #333;
}

.recharge .nav .item.on {
  font-weight: bold;
  border-bottom: 0.04rem solid #e83323;
}

.recharge .info-wrapper {
}

.recharge .info-wrapper .money {
  margin-top: 0.6rem;
  padding-bottom: 0.2rem;
  border-bottom: 1px dashed #ddd;
  text-align: center;
}

.recharge .info-wrapper .money span {
  font-size: 0.56rem;
  color: #333;
  font-weight: bold;
}

.recharge .info-wrapper .money input {
  display: inline-block;
  width: 3rem;
  font-size: 0.84rem;
  text-align: center;
  color: #282828;
  font-weight: bold;
  padding-right: 0.7rem;
}

.recharge .info-wrapper .money input::placeholder {
  color: #fff;
}

.recharge .info-wrapper .money input::-webkit-input-placeholder {
  color: #fff;
}

.recharge .info-wrapper .money input:-moz-placeholder {
  color: #fff;
}

.recharge .info-wrapper .money input::-moz-placeholder {
  color: #fff;
}

.recharge .info-wrapper .money input:-ms-input-placeholder {
  color: #fff;
}

.shuru input::placeholder {
}

.shuru input::-webkit-input-placeholder {
  color: #fff;
}

.shuru input:-moz-placeholder {
  color: #fff;
}

.shuru input::-moz-placeholder {
  color: #fff;
}

.shuru input:-ms-input-placeholder {
  color: #fff;
}

.tip {
  font-size: 0.28rem;
  color: #333333;
  font-weight: 800;
  margin-bottom: 0.14rem;
}

.tip-samll {
  font-size: 0.24rem;
  color: #333333;
  margin-bottom: 0.14rem;
}

.tip-box {
  margin-top: 0.3rem;
}

.recharge .info-wrapper .tips span {
  color: #ef4a49;
}

.recharge .info-wrapper .pay-btn {
  display: block;
  width: 100%;
  height: 0.86rem;
  margin: 0.5rem auto 0 auto;
  line-height: 0.86rem;
  text-align: center;
  color: #fff;
  border-radius: 0.5rem;
  font-size: 0.3rem;
  font-weight: bold;
}

.payment-top {
  width: 100%;
  height: 3.5rem;
  background-color: #e83323;
}

.payment-top .name {
  font-size: 0.26rem;
  color: rgba(255, 255, 255, 0.8);
  margin-top: -0.38rem;
  margin-bottom: 0.3rem;
}

.payment-top .pic {
  font-size: 0.32rem;
  color: #fff;
}

.payment-top .pic-font {
  font-size: 0.78rem;
  color: #fff;
}

.picList .pic-box {
  width: 100%;
  background-color: #ec3323;
  height: auto;
  border-radius: 0.1rem;
  margin-top: 0.21rem;
  padding: 0.3rem 0.2rem;
  display: block;
}

.pic-box-color {
  /* background-color: #f4f4f4; */
  color: #fff;
}

.pic-number {
  font-size: 0.22rem;
}

.pic-number-pic {
  font-size: 0.38rem;
  margin-right: 0.1rem;
  text-align: center;
}

.pic-box-money {
  width: 100%;
  display: block;
}
</style>
